import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import generalReducer from "./../slice/generalSlice";
import incidentsReducer from "./../slice/incidentSlice";
import locationReducer from "./../slice/locationSlice";
import meetingReducer from "./../slice/meetingSlice";
import responderReducer from "./../slice/responderSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "incidents", "location"],
};

const rootReducer = combineReducers({
  incidents: incidentsReducer,
  responder: responderReducer,
  meeting: meetingReducer,
  general: generalReducer,
  location: locationReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/FLUSH",
          "persist/PAUSE",
          "persist/PURGE",
          "persist/REGISTER",
        ],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
